module.exports = __webpack_public_path__ + "img/LF006-05.751bf15a.jpg";